module.exports = __webpack_public_path__ + "img/luck_money.8254f297.png";